/**
 * Dias laborales y no laborales de la empresa.
 *
 * Los endpoints que satisface son: specialDays.
 *
 * @export
 * @class DiaEspecial
 */
export class DiaEspecial {
    id: number;
    nombre: string;
    fecha: string;
    empresa: number;
    tipo: boolean;
  }
/**
 * Dias festivos del pais.
 *
 * Los endpoints que satisface son: holidays.
 *
 * @export
 * @class DiaFestivo
 */
export class DiaFestivo {
    id: number;
    nombre: string;
    fecha: string;
  }



// WEBPACK FOOTER //
// ./src/app/shared/models/dia-especial.model.ts